import { Injectable } from '@angular/core';
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { ConfigProvider } from "../../config-provider.service";
import { LangsProvider } from '../../common/providers/langs-provider';
import { CurrentUser } from "../../common/providers/current-user";
import { CommunicationItemRightsList, CommunicationRights } from './communication-rights';
import { CurrentUserRolesProvider } from '../../organizations/providers/current-user-roles-provider';
import { Observable } from 'rxjs';
import { ApiBaseService } from "../../common/providers/api-base-service";
import { Organization } from "../../common/models/organization";
import { Athlete } from "../../common/models/athlete";
import { Communication } from "../../common/models/communication";
import { map } from "rxjs/operators";


@Injectable({providedIn: 'root'})
export class CommunicationsProvider {
    public Ready: Promise<boolean> = new Promise((resolve, reject) => resolve(false));
    private rights: CommunicationRights = new CommunicationRights(this._utils);
    constructor(
        private _conf: ConfigProvider,
        private _utils: UtilsProvider,
        private api: ApiBaseService,
        private _langs: LangsProvider,
        private _currentUser: CurrentUser,
        private _currentUserRoles: CurrentUserRolesProvider,
    ) {

    }

    public getObservations(organization: Organization, athlete: Athlete): Observable<any> {
        return this.api.call('get',`organizations/${organization.code}/athletes/${athlete.userId}/communications/`, {}, this._currentUser.getAccessToken());
    }

    public saveObservation(organization: Organization, athlete: Athlete, observation: any): Observable<any> {
        return this.api.call('post',
            `organizations/${organization.code}/athletes/${athlete.userId}/communications/`,
            observation,
            this._currentUser.getAccessToken()
        );
    }

    public saveObservationComment(organization: Organization, athlete: Athlete, observation: any, comment: any): Observable<any> {
        return this.api.call('post',
            `organizations/${organization.code}/athletes/${athlete.userId}/communications/${observation.id}/comments/`,
            comment,
            this._currentUser.getAccessToken()
        );
    }

    public deleteObservation(organization: Organization, athlete: Athlete, observation: any): Observable<any> {
        return this.api.call('delete',`organizations/${organization.code}/athletes/${athlete.userId}/communications/${observation.id}`, {}, this._currentUser.getAccessToken()
        );
    }

    public deleteObservationComment(organization: Organization, athlete: Athlete, observation: any, comment: any): Observable<any> {
        return this.api.call('delete',
            `organizations/${organization.code}/athletes/${athlete.userId}/communications/${observation.id}/comments/${comment.id}`, {}, this._currentUser.getAccessToken()
        );
    }

    public getLastCommunication(organizationId: number, athleteId: number): Observable<CommunicationRow> {
      return this.api.call('get',`organizations/${organizationId}/athletes/${athleteId}/communications/`, {}, this._currentUser.getAccessToken()).pipe(
        map((data: any) => {
          this.rights.evaluateItemRight({
              user: this._currentUser.user!,
              organizationId,
              communication: Communication.fromAPI(data),
              rolesIds: this._currentUserRoles.getRolesIds(organizationId),
              athleteCoachRelations: data[1], // TODO : WRONG BUT METHOD NOT USED
              athleteMemberships: data[2], // same
              coaches: data[3], // same
              athlete: data[4] // same
          });

          return this.toCommunicationRow(data[0], this.rights.getItemRightsList());
        }),
      );
        // return new Promise((resolve, reject) => {
        //     Promise.all([
        //         // this._storage.select(Communication)
        //         //     .where('athleteId').equals(athleteId)
        //         //     .get(1),
        //         // this._storage.select(AthleteCoach).get(),
        //         // this._storage.select(OrganizationMembership).get(),
        //         // this._storage.select(Coach).get(),
        //         // this._storage.select(Athlete).where('id').equals(athleteId).get(),
        //     ])
        //         .then((data: any[]) => {
        //
        //             this.rights.evaluateItemRight({
        //                 user: this._currentUser.user,
        //                 organizationId,
        //                 communication: data[0],
        //                 rolesIds: this._currentUserRoles.getRolesIds(organizationId),
        //                 athleteCoachRelations: data[1],
        //                 athleteMemberships: data[2],
        //                 coaches: data[3],
        //                 athlete: data[4]
        //             });
        //
        //             resolve(this.toCommunicationRow(data[0], this.rights.getItemRightsList()));
        //         })
        //         .catch(reject);
        // });
    }

    public saveMessage(organizationId: number, communication: Communication): Promise<Communication> {
      throw new Error('Method not implemented and not used ?.');
        // return new Promise<Communication>((resolve, reject) => {
        //     this.api.call(        //         'post',
        //         'organizations/' + organizationId + '/communications/' + (communication.id ? communication.id : 0),
        //         this._utils.buildModelParams([communication], this._langs.getLangIds())[0],
        //         this._currentUser.getAccessToken()
        //     )
        //         .then((data: any) => {
        //             communication = Communication.fromAPI(data.communication);
        //             this._storage.save([communication])
        //                 .then(() => resolve(communication))
        //                 .catch((error: any) => reject(error));
        //         })
        //         .catch((error: any) => reject(error));
        // });
    }

    public toCommunicationRow(communication: Communication, right: CommunicationItemRightsList): CommunicationRow {

        const row: CommunicationRow = {
            communication,
            rights: right,
        };

        return row;
    }
}

export interface CommunicationRow {
    communication: Communication;
    rights: CommunicationItemRightsList;
}
